import * as React from 'react';
import styled from 'styled-components';
import * as _ from 'lodash/fp';

import { Checkbox } from '@process-advisor/process-miner/components/shared/checkbox';
import { type EndLabelProps } from '@process-advisor/process-miner/api/methods/settings/changeStartEndLabels';
import { apiProvider } from '@process-advisor/process-miner/api/apiProvider';
import { Event } from '@process-advisor/process-miner/api/events';

const Wrapper = styled.div`
`;

export const EndLabel = () => {
    const [EndLabel, setEndLabel] = React.useState<EndLabelProps>({});
    const onChange = _.curry((
        key: keyof EndLabelProps,
        e: React.ChangeEvent<HTMLInputElement>
    ) => {
        const newEndLabel = { ...EndLabel, [key]: e.target.checked };
        setEndLabel(newEndLabel);
        apiProvider.changeEndLabel(newEndLabel);
        if (apiProvider.getActiveAction() ==='process_miner')  apiProvider.rebuildPVDiagram({});
    });

    React.useEffect(() => {
        setEndLabel(apiProvider.getEndLabel());
    }, []);

    React.useEffect(() => {
        const listener = () =>
            setEndLabel(apiProvider.getEndLabel());
        listener();

        apiProvider.on(Event.loadProcessMinerSettings, listener);

        return () => {
            apiProvider.off(Event.loadProcessMinerSettings, listener);
        };
    }, []);

    return (
        <Wrapper>
            <Checkbox
                label=''
                checked={!!EndLabel.visible}
                handleOnChange={onChange('visible')} />
        </Wrapper>
    );
};
